import React from "react";
import DashBoardPanel from "./DashBoardPanel";

function EilgableHoursPanel(props) {
  // Add safety check for data
  const data = props.data || [];

  return (
    <DashBoardPanel title="Hours this Quarter by Project">
      {!props.isLoaded ? <div>Loading data...</div> :
       <table className="table table-hover">
        <thead>
          <tr key="EligableHoursTableHeaders">
            <th>Project</th>
            <th>Task</th>
            <th>Rev Share Eligible</th>
            <th>Hours</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr
              key={
                (item.projectCode || "").toString() +
                (item.taskName || "").toString() +
                (item.consultantGUID || "").toString() +
                Math.random(1000)
              }
            >
              <td>{item.projectCode || ""}</td>
              <td>{item.taskName || ""}</td>
              <td>{item.isRevShareEligable ? "Yes" : "No"}</td>
              <td>{item.hours || 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    }
    </DashBoardPanel>
  );
}

export default EilgableHoursPanel;